import { gql } from '@apollo/client';

// eslint-disable-next-line import/prefer-default-export
export const SUSTAINABILITY_DATA = gql`
{
  sustainabilityData
}
`;
